module.exports = __webpack_public_path__ + "img/P150T_weapon_5.d1f2c7c5.png";